<template>
    <m-layout>

        <div fill-height class="fill-height" style="width:100%">
          <m-todo></m-todo>
        </div>


    </m-layout>
</template>
<script>
import Todo from '@/components/todo/todo';

export default {
  name: 'home',
  components: {
    'm-todo': Todo
  }
}
</script>
<style lang="scss">
.logo-home {
  opacity: 0.1;
  margin: 0 auto;
}
</style>
